import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import img from "../WhatsApp Image 2024-05-10 at 2.49.27 PM.jpeg";
import { getMenuItems } from "../utils/permissionUtils";

const CommonHeader = () => {
  const navigate = useNavigate();
  const [isDesktopMenuOpen, setIsDesktopMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userPermissions"); // Clear permissions on logout
    navigate('/');
  };

  const handleMenuClick = (path) => {
    navigate(path);
    setIsDesktopMenuOpen(false);
    setIsMobileMenuOpen(false);
  };

  const menuItems = getMenuItems();

  return (
    <header class="bg-surface-primary border-bottom pt-6">
      <div class="container-fluid">
        <div class="mb-npx">
          <div class="row align-items-center mb-6">
            <div class="col-sm-6 col-6 mb-4 mb-sm-0">
              <img src={img} alt="" style={{ width: "4em" }} />
            </div>

            {/* Mobile Menu Button */}
            <div class="col-sm-6 col-6 text-sm-end d-lg-none">
              {menuItems.length > 0 && (
                <div class="dropdown me-2" style={{ position: "relative" }}>
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    style={{ minWidth: "40px" }}
                  >
                    <i class="bi bi-list"></i>
                  </button>
                  {isMobileMenuOpen && (
                    <ul class="dropdown-menu show" style={{ 
                      position: "absolute", 
                      top: "100%", 
                      right: "0", 
                      zIndex: "1000",
                      minWidth: "200px",
                      maxHeight: "300px",
                      overflowY: "auto",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                    }}>
                      {menuItems.map((item, index) => (
                        <li key={index}>
                          <a class="dropdown-item" href="#" onClick={() => handleMenuClick(item.path)}>
                            <i class={`bi ${item.icon} me-2`}></i>
                            {item.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
              <button
                class="btn d-inline-flex btn-sm btn-neutral border-base"
                onClick={handleLogout}
              >
                <span class="pe-2">
                  <i class="bi bi-box-arrow-left"></i>
                </span>
                <span>Log Out</span>
              </button>
            </div>

            {/* Desktop Navigation */}
            <div class="col-sm-6 col-12 text-sm-end d-none d-lg-block">
              <div class="mx-n1 d-flex align-items-center">
                {menuItems.length > 0 && (
                  <div class="dropdown me-3" style={{ position: "relative" }}>
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      onClick={() => setIsDesktopMenuOpen(!isDesktopMenuOpen)}
                      style={{ minWidth: "120px" }}
                    >
                      <i class="bi bi-list me-2"></i>
                      Menu
                      <i class={`bi bi-chevron-down ms-2 ${isDesktopMenuOpen ? 'rotate-180' : ''}`}></i>
                    </button>
                    {isDesktopMenuOpen && (
                      <ul class="dropdown-menu show" style={{ 
                        position: "absolute", 
                        top: "100%", 
                        right: "0", 
                        zIndex: "1000",
                        minWidth: "200px",
                        maxHeight: "400px",
                        overflowY: "auto",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        border: "1px solid #dee2e6",
                        borderRadius: "0.375rem"
                      }}>
                        {menuItems.map((item, index) => (
                          <li key={index}>
                            <a class="dropdown-item" href="#" onClick={() => handleMenuClick(item.path)}>
                              <i class={`bi ${item.icon} me-2`}></i>
                              {item.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}

                <button
                  class="btn d-inline-flex btn-sm btn-neutral border-base"
                  onClick={handleLogout}
                >
                  <span class="pe-2">
                    <i class="bi bi-box-arrow-left"></i>
                  </span>
                  <span>Log Out</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default CommonHeader; 